<template>
	<Dialog :dialog="lockDialog">
		<template v-slot:title> Lock {{ toBeLock.name }}</template>
		<template v-slot:body>
			<v-layout>
				<v-flex md4>
					<label for="password">Password</label>
				</v-flex>
				<v-flex md8>
					<text-input
						:append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
						v-on:click:append="show_password = !show_password"
						:type="show_password ? 'text' : 'password'"
						id="password"
						v-model="password"
						hide-details
						placeholder="Enter Password..."
						:disabled="loading"
						:loading="loading"
					></text-input>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex md4>
					<label for="confirm-password">Confirm Password</label>
				</v-flex>
				<v-flex md8>
					<text-input
						:append-icon="show_confirm ? 'mdi-eye' : 'mdi-eye-off'"
						v-on:click:append="show_confirm = !show_confirm"
						:type="show_confirm ? 'text' : 'password'"
						id="confirm-password"
						v-model="confirm_password"
						hide-details
						placeholder="Re-Enter Password..."
						:disabled="loading"
						:loading="loading"
						v-on:keyup-enter="lock_folder()"
					></text-input>
				</v-flex>
			</v-layout>
		</template>
		<template v-slot:action>
			<v-btn :disabled="loading" depressed tile v-on:click="$emit('close', true)">Cancel</v-btn>
			<v-btn
				:disabled="loading"
				:loading="loading"
				depressed
				tile
				color="blue darken-4 white--text"
				v-on:click="lock_folder()"
				>Lock</v-btn
			>
		</template>
	</Dialog>
</template>

<script>
import Dialog from "@/view/components/Dialog";
import TextInput from "@/view/components/TextInput";
import { PATCH } from "@/core/services/store/request.module";

export default {
	name: "lock-dialog",
	props: {
		lockDialog: {
			type: Boolean,
			default: false,
		},
		toBeLock: {
			type: Object,
			default() {
				return {
					uuid: null,
					type: null,
					name: null,
					created: {
						datetime: null,
					},
				};
			},
		},
	},
	data() {
		return {
			password: null,
			confirm_password: null,
			loading: false,
			show_password: false,
			show_confirm: false,
		};
	},
	watch: {
		lockDialog(param) {
			if (param) {
				this.password = null;
				this.confirm_password = null;
			}
		},
	},
	methods: {
		lock_folder() {
			this.loading = true;
			this.$store
				.dispatch(PATCH, {
					url: `folders/${this.toBeLock.uuid}/lock`,
					data: { password: this.password, password_confirmation: this.confirm_password },
				})
				.then(() => {
					this.$emit("close", true);
					this.$emit("success", true);
				})
				.catch((error) => {
					console.log({ error });
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
	components: {
		Dialog,
		"text-input": TextInput,
	},
};
</script>
